import { type ComponentProps, type ReactNode, useState } from 'react'
import { cn } from '../lib/cn'
export function Media({
  src,
  alt,
  fallback,
  className,
  aspect = 'landscape',
  fit = 'cover',
  loading = 'lazy',
  onError,
  ...props
}: Omit<ComponentProps<'img'>, 'alt'> & {
  alt: string
  fallback?: ReactNode
  aspect?: 'landscape' | 'square' | 'wide'
  fit?: 'cover' | 'contain'
}) {
  const [failedSrc, setFailedSrc] = useState<string>()
  const unavailable = !src || src === failedSrc
  return (
    <div
      data-slot="media"
      className={cn(
        'relative overflow-hidden bg-muted',
        aspect === 'square' ? 'aspect-square' : aspect === 'wide' ? 'aspect-[2/1]' : 'aspect-[4/3]',
        className,
      )}
    >
      {unavailable ? (
        <div
          className="grid h-full place-items-center text-muted-foreground"
          role="img"
          aria-hidden={!alt || undefined}
          aria-label={alt}
        >
          {fallback}
        </div>
      ) : (
        <img
          {...props}
          src={src}
          alt={alt}
          loading={loading}
          className={cn('h-full w-full', fit === 'cover' ? 'object-cover' : 'object-contain')}
          onError={(event) => {
            setFailedSrc(src)
            onError?.(event)
          }}
        />
      )}
    </div>
  )
}
